import React, { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import InputImgBigger from 'components/InputImgBigger';
import useWindowSize from 'hooks/useWindowSize';
import { UseTranslationProps } from 'types/UseTranslationProps';
import { getGeneralSettings, saveImgLoginOrMenu } from './reqs';
import SystemNotifyContext from 'context/SystemNotifyContext';
import LoadGeneralContext from 'context/LoadGeneralContext';
import { GeneralSettingsProps } from 'types/GeneralSettingsProps';
import { ImgSavedProps } from 'types/ImgSavedProps';
import { deleteImageOnServer } from 'utils/functions';

interface GeneralSettingsPropsComponent {
	isVisiable: boolean;
}

export default function GeneralSettings({
	isVisiable
}: GeneralSettingsPropsComponent) {
	const { t }: UseTranslationProps = useTranslation();
	const { width } = useWindowSize();
	const { handleNotify } = useContext(SystemNotifyContext);
	const { setIsOpenLoad, setMessage } = useContext(LoadGeneralContext);

	const [settingsData, setSettingsData] = useState<GeneralSettingsProps[]>([]);

	function returnDataByText(text: 'image_menu' | 'image_login') {
		const item = settingsData.find((item) => item.name === text);

		return item?.file?.url || '';
	}

	function returnIdImg(text: 'image_menu' | 'image_login') {
		const item = settingsData.find((item) => item.name === text);

		return item?.file_id || '';
	}

	async function saveImg(
		newPhoto: ImgSavedProps,
		localToSave: 'image_menu' | 'image_login'
	) {
		if (newPhoto && newPhoto.id) {
			const { data, isSuccess } = await saveImgLoginOrMenu(
				newPhoto.id,
				localToSave,
				handleNotify
			);

			if (isSuccess && data !== null) {
				setSettingsData((obj) => {
					const newList = obj.map((item) => {
						if (item.name === localToSave) {
							item.file = newPhoto;
							item.file_id = item.id;
						}

						return item.name === localToSave ? data : item;
					});
					return newList;
				});
			}
		}
	}

	async function deleteImg(
		idImg: string,
		typeImg: 'image_menu' | 'image_login'
	) {
		setIsOpenLoad(true);
		setMessage('Deletando imagem');
		const { isSuccess } = await deleteImageOnServer(idImg, handleNotify, t);

		if (isSuccess) {
			setSettingsData((obj) => {
				const newList = obj.map((item) => {
					if (item.name === typeImg) {
						item.file = null;
						item.file_id = null;
					}

					return item;
				});
				return newList;
			});
		}

		setIsOpenLoad(false);
	}

	useEffect(() => {
		(async () => {
			const { data, isSuccess } = await getGeneralSettings(
				handleNotify,
				setIsOpenLoad,
				setMessage
			);

			if (isSuccess && data.length > 0) {
				setSettingsData(data);
			}
		})();
	}, []);

	return (
		<S.container $isShow={isVisiable}>
			<InputImgBigger
				functionToDeleteImgFromBack={() =>
					deleteImg(returnIdImg('image_menu'), 'image_menu')
				}
				showDelteImageFromBackBtn={
					returnDataByText('image_menu') === '' ? false : true
				}
				label={t('settings.generalSettings.appLogo')}
				getImage={async (newPhoto: ImgSavedProps) => {
					await saveImg(newPhoto, 'image_menu');
				}}
				initialImage={returnDataByText('image_menu') || ''}
				idImagem="logoApp"
				imgHeight={width !== undefined && width > 1100 ? 300 : 190}
			/>

			<InputImgBigger
				functionToDeleteImgFromBack={() =>
					deleteImg(returnIdImg('image_login'), 'image_login')
				}
				showDelteImageFromBackBtn={
					returnDataByText('image_login') === '' ? false : true
				}
				label={t('settings.generalSettings.loginImg')}
				getImage={async (newPhoto: ImgSavedProps) => {
					await saveImg(newPhoto, 'image_login');
				}}
				initialImage={returnDataByText('image_login') || ''}
				idImagem="logoLogin"
				imgHeight={width !== undefined && width > 1100 ? 300 : 190}
			/>
		</S.container>
	);
}
